import { AppData, Lightning } from '@lightningjs/sdk';
import PortraitTile from 'components/common/tiles/PortraitTile';
import DefaultCarousel from 'components/common/carousels/DefaultCarousel';
import { ROW_LIST_OFFSET_Y } from 'components/common/carousels/Carousel';
import { Show } from 'types/api/media';

const HORIZONTAL_PADDING = 96;
const TOP_MARGIN = 24;

export interface RecommendedSectionPageSpec
  extends Lightning.Component.TemplateSpec {
  recommended: Show[];

  RecommendedList: typeof DefaultCarousel;
}

export default class RecommendedSection
  extends Lightning.Component<RecommendedSectionPageSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<RecommendedSectionPageSpec>
{
  private _RecommendedList = this.getByRef('RecommendedList')!;

  set recommended(recommended: Show[]) {
    this._RecommendedList.patch({
      visible: !!recommended.length,
      label: AppData?.tivoEndpoints?.details_recommended_v2.title,
      laneItems: recommended,
    });
  }

  static override _template(): Lightning.Component.Template<RecommendedSectionPageSpec> {
    return {
      RecommendedList: {
        type: DefaultCarousel,
        x: HORIZONTAL_PADDING,
        y: TOP_MARGIN,
        w: 1920 - 2 * HORIZONTAL_PADDING,
        h: PortraitTile.height + ROW_LIST_OFFSET_Y,
        // @ts-ignore
        listType: PortraitTile,
        imageKey: 'image_vertical',
        itemWidth: PortraitTile.width,
        passSignals: {
          $onHover: '$onRecommendedHover',
        },
        navBarOffset: HORIZONTAL_PADDING,
        isNavBarVisible: false,
      },
    };
  }

  override _getFocused() {
    return this._RecommendedList;
  }
}
